import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const mapAnnotationService = {
  getList,
  storeOrUpdate,
  destroy
};

function getList(propertyId, layerId) {
  const params = layerId ? `property_id=${propertyId}&layer_id=${layerId}` : `property_id=${propertyId}`;
  return axios
    .get(`${apiEndpoint.mapAnnotations}?${params}`, {
      headers: authHeader(),
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { code: 'error', message: 'Request failed' };
    });
}

function storeOrUpdate(data, id = null) {
  return (id
    ? axios.put(apiEndpointFunction.mapAnnotations(id), data, { headers: authHeader() })
    : axios.post(apiEndpoint.mapAnnotations, data, { headers: authHeader() })
  ).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.mapAnnotations(id), { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
